import React from "react";
import CheckBox from "../CheckBox/CheckBox";
import InputGroup from "../Inputs/InputGroup";
import _ from "lodash";

const VerticalCheckBoxes = ({
    formData,
    options,
    onChangeHandler,
    inputChangeHandler,
    wrapperClassName = "my-1",
    disabled = false,
    includeInput = false,
    inputLabel = "",
    inputPlaceHolder = "",
}) => {
    return (
        <>
            {options &&
                options.map((option, index) => {
                    return (
                        <div
                            className={` ${
                                disabled ? "opacity-60" : ""
                            } ${wrapperClassName}`}
                            key={index}
                        >
                            <CheckBox
                                name={option.value}
                                checked={
                                    _.isBoolean(formData[option.value])
                                        ? formData[option.value]
                                        : formData[option.value]?.booleanValue
                                }
                                onChangeHandler={onChangeHandler}
                                label={option.label}
                                labelClassName="!font-medium"
                                includeTextInput={true}
                            />

                            {includeInput && (
                                <InputGroup
                                    type="number"
                                    name={option.value}
                                    value={
                                        _.isObject(formData[option.value])
                                            ? formData[option.value]?.inputValue
                                            : formData[option.value]
                                    }
                                    onChangeHandler={inputChangeHandler}
                                    label={inputLabel}
                                    placeholder={inputPlaceHolder}
                                    wrapperClassNames="pl-8"
                                    inputClassNames="!h-6"
                                    customClassNames="mt-2"
                                    disabled={
                                        !(_.isBoolean(formData[option.value])
                                            ? formData[option.value]
                                            : formData[option.value]
                                                  ?.booleanValue)
                                    }
                                />
                            )}
                        </div>
                    );
                })}
        </>
    );
};

export default VerticalCheckBoxes;
